module.exports = __webpack_public_path__ + "img/zs-1.88b92fd1.png";